import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class StatusPostaService {
    private token!: string;
    private basePath = environment.interop.basePath;

    public listDTUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.statusPosta.listDT;
    private listUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.statusPosta.list;
    private listActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.statusPosta.listActive;
    private listPublicUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.statusPosta.listPublic;
    private populateUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.statusPosta.populate;

    private changeStatusActiveUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.statusPosta.active;
    private changeStatusPublicUrl = this.basePath + environment.interop.indoc.nomenclatoare.registratura.statusPosta.public;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    getList() {
        return this.http.get(this.listUrl, this.httpOptions);
    }

    getListActive() {
        return this.http.get(this.listActiveUrl, this.httpOptions);
    }

    getListPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    populate() {
        return this.http.get(this.populateUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
